import React from 'react';
import OurAssociation from "../OurAssociation/OurAssociation";

const OurServicesCard = ({ image, heading, desc, link, isOurAssociation }) => {
    return (
        <div className={`bg-[#F0F5F8] rounded-[6px] mx-3 flex flex-col ${isOurAssociation ? "h-[530px]" : "h-[600px]"}`}>
            <div className="h-[180px]">
                <img src={image} alt="" className="w-full h-full rounded-t-[6px] object-cover" />
            </div>
            <div className="flex flex-col justify-between items-start w-[90%] p-5 flex-grow">
                <div className="font-poppins text-[14px] text-start font-[700]">
                    {heading}
                </div>
                <div className="font-poppins text-[12px] font-[300] my-3 flex-grow">
                    {desc}
                </div>
                {link && (
                    <div>
                        <div className="font-poppins text-[12px] font-[300] mt-3">For more Information, please visit:</div>
                        <a href={link}
                           className="text-blue-600 visited:text-purple-600 underline"
                           target="_blank" rel="noopener noreferrer">
                            Click Here
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
}

export default OurServicesCard;
